import api from "./api";

const { vendorServiceAPI, iamServiceAPI } = api;

const FETCH_VENDOR_USER_MANAGEMENT_ONLOAD_PATH = "/vendorUserManagement/onload";
const FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH = "/vendorUserManagement";
const FETCH_VENDOR_USER_MANAGEMENT_LIST_BY_VENDOR_ID_PATH = "/vendorUserManagement?vendorId=";
const FETCH_VENDOR_USER_MANAGEMENT_EDIT_PATH = "/vendorUserManagement/detail";

const VendorUserManagementService = {
  getVendorUserOnloadData: async () => {
    try {
      const resp = await vendorServiceAPI.get(FETCH_VENDOR_USER_MANAGEMENT_ONLOAD_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  getVendorUserManagementList: async () => {
    try {
      const resp = await iamServiceAPI.get(FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  getVendorUserManagementListByVendorId: async (vendorId: string) => {
    try {
      const resp = await iamServiceAPI.get(`${FETCH_VENDOR_USER_MANAGEMENT_LIST_BY_VENDOR_ID_PATH}${vendorId}`);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  deleteVendorUser: async (vendorId: string) => {
    try {
      const resp = await vendorServiceAPI.delete(`${FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH}/${vendorId}`);
      return resp.status;
    } catch (error) {
      throw error;
    }
  },

  getVendorUserEditData: async (vendorUserId: string) => {
    try {
      const resp = await iamServiceAPI.get(`${FETCH_VENDOR_USER_MANAGEMENT_EDIT_PATH}/${vendorUserId}`);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  createVendorUser: async (vendorUserData: any) => {
    try {
      const resp = await vendorServiceAPI.post(FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH, vendorUserData);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Create vendor user via IAM (new contract for Add Vendor User flow).
   * POST `/vendorUserManagement` on `iam-service`.
   */
  createVendorUserInIam: async (vendorUserData: any) => {
    try {
      const resp = await iamServiceAPI.post(FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH, vendorUserData);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Update vendor user via IAM (new contract for Modify User flow).
   * PUT `/vendorUserManagement/{vendorUserId}` on `iam-service`.
   */
  updateVendorUserInIam: async (vendorUserId: string, vendorUserData: any) => {
    try {
      const id = String(vendorUserId ?? "").trim();
      const resp = await iamServiceAPI.put(`${FETCH_VENDOR_USER_MANAGEMENT_LIST_PATH}/${id}`, vendorUserData);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
};

export default VendorUserManagementService;
